import React from 'react';
import { cooperOuter as defaultOptions } from 'pu-data/SelectOptions';
import { copperWeight as tooltip } from 'pu-data/Tooltips';
import SelectComponent from './SelectComponent';

const CopperWeightOuters = (props) => {
  const name = 'copper_outers';
  const onChange = e => props.onChangeParameter(name, e.target.value);
  return (
    <SelectComponent
      label="Copper Weight"
      required={props.required}
      name={name}
      onChange={onChange}
      options={props.options}
      tooltip={tooltip}
      selected={props.parameters[name]}
      groupName={props.groupName} />
  );
};

CopperWeightOuters.defaultProps = {
  // innerOptions: defaultInnerOptions,
  // outerOptions: defaultOuterOptions,
  options : defaultOptions,
  required: true,
};

export default CopperWeightOuters;
